import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import Grid from '@material-ui/core/Grid'
import Quiz from './Quiz';
import Result from './Result';
import Sending from './Sending';
import { Base64 } from '../../modules/util'
import './App.css';
import QnA from './api/QnA.json'
import { RESULT_URL } from '../../client_url_constant'

const quizQuestions = QnA["QnA"]

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questionId: 1,
      selectedAnswer:'',
      hasDone: false,
      hasSent: false,
      answers: {
        1:'',	2:'',	3:'',	4:'',	5:'',	6:'',	7:'',	8:'',	9:'',	10:'',	
        11: '',	12:'',	13:'',	14: '',15:'',	16:'',	17:'',	18:'',	19:'',	20:'',	
        21: '',	22:'',	23:'',	24: '',	25:'',	26:'',	27:'',	28:'',	29:'',	30:'',	
        31: '',	32:'',	33:'',	34: '',	35:'',	36:'',	37:'',	38:'',	39:'',	40:'',	
        41: '',	42:'',	43:'',	44: '',45:'',	46:'',	47:'',	48:'',	49:'',	50:'',	
        51: '',52:'',	53:'',	54: '',	55:'',	56:'',	57:'',	58:'',	59:'',	60:'',	
        61: '',62:'',	63:'',	64: '',	65:'',	66:'',	67:'',	68:'',	69:'',	70:'',	
        71: '',	72:'',	73:'',	74: '',75:'',	76:'',	77:'',	78:'',	79:'',	80:'',	
        81: '',	82:'',	83:'',	84: '',	85:'',	86:'',	87:'',	88:'',	89:'',	90:'',
        91: '',92:'',	93:'',	94: '',95:'',	96:'',	97:'',	98:'',	99:'',	100:'',
        101: '', 102: '', 103: '', 104: '', 105: '', 106: ''
      },
      startDate: this.props.startDate,
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.goBackQuestion = this.goBackQuestion.bind(this);
    this.finish = this.finish.bind(this) ;
    this.setSelectedAnswer = this.setSelectedAnswer.bind(this)
    this.syncFinish = this.syncFinish.bind(this);
    this.getBodyParams = this.getBodyParams.bind(this);
    this.changeQuestionId = this.changeQuestionId.bind(this)
  }


  componentWillMount() {
    this.setState({
      question: quizQuestions[0]["question"],
      answerOptions: quizQuestions[0]["answers"],
      logo: quizQuestions[0]["img"],
      answerType: '',
    });
  }


  handleAnswerSelected(answer) {
    this.setSelectedAnswer(answer);

    if (this.state.questionId < quizQuestions.length) {
      /* 次の問題へ */
      this.setNextQuestion()
    } else {
      /* テスト終了時 */
      this.finish()
    }
  }

  changeQuestionId(questionId) {
    console.log({questionId});
    
    this.setState({
      questionId,
      selectedAnswer: this.state.answers[questionId]
    });
  }


  setNextQuestion() {
    const questionId = this.state.questionId + 1;
    this.changeQuestionId(questionId);
  }

  goBackQuestion(answer) {
    if (this.state.questionId <= quizQuestions.length) {
      /* 前の問題へ */
      this.setLastQuestion();
    }
  }

  setLastQuestion() {
    const questionId = this.state.questionId - 1;
    this.changeQuestionId(questionId);
  }

  setSelectedAnswer(selectedAnswer){
    const updatedAnswers = update(this.state.answers, {
      [this.state.questionId]: {$apply: (currentValue) => selectedAnswer}
    });
    this.setState({
        answers: updatedAnswers,
        selectedAnswer
    });
  }

  async finish() {
    this.setState({
      hasDone:true,
    })
    const body = this.getBodyParams();
    const method = "POST";
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    const res = await fetch(RESULT_URL, {method, headers, body})
    const result = await res.json()
    await this.setState({
      hasSent: true,
    });
  }

  syncFinish() {
    if (this.state.hasDone) return;
    this.setState({
      hasDone: true,
    });
    try {
      const xmlhttp = new XMLHttpRequest();
      const data = this.getBodyParams();
      xmlhttp.open("POST", RESULT_URL, false); //the false is for making the call synchronous
      xmlhttp.setRequestHeader("Content-type", "application/json");
      xmlhttp.send(data);

    } catch (err) {
      console.error(err)
    }
  }

  getBodyParams() {
    const encodedEmail = sessionStorage.getItem('ad_tst_ref');
    const email = Base64.decode(encodedEmail);
    const finish_date = new Date()
    let answers = this.state.answers
    const id = this.state.questionId
    answers[id] = this.state.selectedAnswer

    return JSON.stringify({
      email,
      examination: {
        finish_date,
        answers
      }
    });
  }

  componentWillReceiveProps(nextProps){
    if((nextProps.hasDone) && (!this.props.hasDone)){
      this.props.endTimer()
      this.finish();
    }
  }

  renderQuiz() {
    
    const counter = this.state.questionId - 1
    const question = quizQuestions[counter]["question"]
    const logo = quizQuestions[counter]["img"]
    const answerOptions = quizQuestions[counter]["answers"]

    return (
      <Grid container spacing={3}>
        <Grid item xs={12} >
          <Quiz
            answers={this.state.answers}
            answerOptions={answerOptions}
            questionId={this.state.questionId}
            question={question}
            questionTotal={quizQuestions.length}
            changeQuestionId={this.changeQuestionId}
            logo={logo}
            next={this.handleAnswerSelected}
            back={this.goBackQuestion}
            hasDone={this.state.hasDone}
            finishFunc={this.syncFinish}
            selectedAnswer={this.state.selectedAnswer}
            setSelectedAnswer={this.setSelectedAnswer}
            finishButtonFunc={this.props.finishButtonFunc}
          />
        </Grid>

      </Grid>
    );
  }

  renderResult() {
      return (
        <Result />
      );
  }

  rederSending() {
    return (
      <Sending />
    )
  }

  render() {
    return (
      <div className="App">
        {!this.state.hasDone && !this.state.hasSent ? this.renderQuiz() : null }
        {this.state.hasDone && !this.state.hasSent ? this.rederSending(): null }
        {this.state.hasDone && this.state.hasSent ? this.renderResult(): null}
      </div>
    );
  }
}

App.propTypes={
  finishButtonFunc : PropTypes.func.isRequired,
  hasDone : PropTypes.bool.isRequired,
  endTimer: PropTypes.func.isRequired,
}

export default App;



// WEBPACK FOOTER //
// ./src/components/quiz/App.js